import React, { useEffect, useState } from "react";

// FAQ Accordion Item Component
const FAQItem = ({ question, answer, index, isOpen, onToggle }) => {
  return (
    <div className="faq-accordion-item">
      <button
        className={`faq-question ${isOpen ? "active" : ""}`}
        onClick={() => onToggle(index)}
        aria-expanded={isOpen}
      >
        <span className="faq-question-text">{question}</span>
        <i className={`icofont-rounded-${isOpen ? "up" : "down"} faq-icon`}></i>
      </button>
      <div className={`faq-answer ${isOpen ? "open" : ""}`}>
        <div className="faq-answer-content">
          <p>{answer}</p>
        </div>
      </div>
    </div>
  );
};

const Content = () => {
  // State to track which FAQ item is open (null means none is open)
  const [openIndex, setOpenIndex] = useState(null);

  // Function to handle FAQ item toggle
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    // Initialize partners carousel after component mounts
    const initializeCarousel = () => {
      if (window.$ && window.$.fn.owlCarousel) {
        const $carousel = window.$("#partners-carousel-about");

        // Destroy existing carousel if it exists
        if ($carousel.length && $carousel.data("owlCarousel")) {
          $carousel.trigger("destroy.owl.carousel");
          $carousel.removeClass("owl-carousel owl-loaded");
          $carousel.find(".owl-stage-outer").children().unwrap();
        }

        // Initialize carousel
        if ($carousel.length) {
          $carousel.owlCarousel({
            items: 4,
            margin: 30,
            loop: true,
            nav: true,
            slideBy: 1,
            dots: true,
            center: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            autoheight: false,
            navText: [
              '<i class="icofont-thin-left"></i>',
              '<i class="icofont-thin-right"></i>',
            ],
            responsive: {
              0: {
                items: 2,
                margin: 15,
              },
              480: {
                items: 2,
                margin: 20,
              },
              768: {
                items: 3,
                margin: 25,
              },
              992: {
                items: 4,
                margin: 30,
              },
              1200: {
                items: 5,
                margin: 30,
              },
            },
          });
        }
      }
    };

    // Wait for DOM to be ready and jQuery to be available
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializeCarousel);
    } else {
      // DOM is already ready, try to initialize
      setTimeout(initializeCarousel, 100);
    }

    // Also try after a short delay to ensure jQuery is loaded
    const timer = setTimeout(initializeCarousel, 500);

    return () => {
      clearTimeout(timer);
      // Cleanup: destroy carousel on unmount
      if (window.$ && window.$("#partners-carousel-about").length) {
        const $carousel = window.$("#partners-carousel-about");
        if ($carousel.data("owlCarousel")) {
          $carousel.trigger("destroy.owl.carousel");
        }
      }
    };
  }, []);

  return (
    <>
      <main id="body-content">
        <section className="wide-tb-80 pb-0">
          <div className="container pos-rel">
            <div className="row align-items-center">
              <div
                className="col-md-6 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h2 className="mb-4 fw-7 txt-blue">
                  A propos de <span className="fw-6 txt-orange">Log2Trans</span>
                </h2>
                <p>
                  Nous sommes Commissionnaire Agrée en Douanes sous le numéro
                  6729/MINFI/DGD3/CDL depuis 2013.{" "}
                </p>

                <p>
                  Nos prestations sont effectuées depuis sous palan Douala,
                  Kribi et Yaoundé rendu à votre site ou toute autre destination
                  de votre choix, non dépoté, dédouané, hors droits et taxes de
                  douane, avec assurance locale exigible.
                </p>
                <p>Nous sommes spécialistes en : </p>
                <ul className="list-unstyled icons-listing theme-orange mb-0 ml-2">
                  <li>
                    <i className="icofont-dotted-right"></i>Commission en Douane
                  </li>
                  <li>
                    <i className="icofont-dotted-right"></i>Logistique
                    industrielle et pétrolière
                  </li>
                  <li>
                    <i className="icofont-dotted-right"></i>Transport et
                    Manutention
                  </li>
                  <li>
                    <i className="icofont-dotted-right"></i>Intermédiation dans
                    le commerce international
                  </li>
                  <li>
                    <i className="icofont-dotted-right"></i>Conseil en
                    achat/vente à l’international
                  </li>
                  <li>
                    <i className="icofont-dotted-right"></i>Conseil en
                    procédures douanières.
                  </li>
                </ul>
                <p>
                  Notre force est de pouvoir s'associer, si besoin, aux
                  compétences des sociétés partenaires spécialisées.{" "}
                </p>
              </div>
              <div
                className="col-md-6 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <img src="images/map-bg-orange.jpg" alt="" />
              </div>
            </div>
          </div>
        </section>
        {/* <section className="bg-light-gray wide-tb-100 pb-5 why-choose">
                    <div className="container pos-rel">
                        <div className="row">
                            <div className="col-sm-12 wow fadeInDown" data-wow-duration="0" data-wow-delay="0s">
                                <h1 className="heading-main">
                                    <span>Our Goodness</span>
                                    What Makes Us Special
                                </h1>
                            </div>
                            <div className="col-12 col-lg-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0s">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-id"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Trusted Franchise</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-live-support"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Customer Support</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4 wow fadeInUp" data-wow-duration="0" data-wow-delay="0.4s">
                                <div className="icon-box-2">
                                    <div className="media">
                                        <div className="service-icon">
                                            <i className="icofont-history"></i>
                                        </div>
                                        <div className="service-inner-content media-body">
                                            <h4 className="h4-md">Reliability & Punctuality</h4>
                                            <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis. Vivamus ac ultrices diam, vitae accumsan tellus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
        {/* <section className="wide-tb-60 p-0 bg-light-gray">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1 wow pulse animated" data-wow-duration="0" data-wow-delay="0.7s">
                                <div className="bg-fixed pos-rel video-popup">
                                    <div className="bg-overlay black opacity-50"></div>
                                    <div className="zindex-fixed pos-rel">
                                        <a href="#" className="play-video"><i className="icofont-play icofont-4x"></i></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section> */}
        <section className="wide-tb-100 mb-spacer-md">
          <div className="container pb-0">
            <div className="row d-flex align-items-center">
              <div
                className="col col-12 col-lg-3 col-sm-6 wow slideInUp"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="counter-style-1 light-bg">
                  <p className="mb-1">
                    <i className="icofont-google-map"></i>
                  </p>
                  <span className="counter">15</span>
                  <div>Sites</div>
                </div>
              </div>
              <div
                className="col col-12 col-lg-3 col-sm-6 wow slideInUp"
                data-wow-duration="0"
                data-wow-delay="0.3s"
              >
                <div className="counter-style-1 light-bg">
                  <p className="mb-1">
                    <i className="icofont-globe"></i>
                  </p>
                  <span className="counter">110</span>
                  <span>+</span>
                  <div>Clients</div>
                </div>
              </div>
              <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
              <div
                className="col col-12 col-lg-3 col-sm-6 wow slideInUp"
                data-wow-duration="0"
                data-wow-delay="0.6s"
              >
                <div className="counter-style-1 light-bg">
                  <p className="mb-1">
                    <i className="icofont-vehicle-delivery-van"></i>
                  </p>
                  <span className="counter">240</span>
                  <span>+</span>
                  <div>Véhicles</div>
                </div>
              </div>
              <div
                className="col col-12 col-lg-3 col-sm-6 wow slideInUp"
                data-wow-duration="0"
                data-wow-delay="0.9s"
              >
                <div className="counter-style-1 light-bg">
                  <p className="mb-1">
                    <i className="icofont-umbrella-alt"></i>
                  </p>
                  <span className="counter">2340</span>
                  <div>Tonnes Transportées</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="pos-rel bg-sky-blue">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-5 col-12 p-0">
                <img src="images/why-choose-us.jpg" className="w-100" alt="" />
              </div>
              <div className="col-lg-6 col-12">
                <div className="p-5 about-whoose">
                  <h1 className="heading-main text-left mb-4">
                    <span>Pourquoi choisir</span>
                    Log2Trans
                  </h1>
                  <ul className="list-unstyled icons-listing theme-orange mb-0">
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0s"
                    >
                      <i className="icofont-check"></i>La mise à disposition
                      d’informations en temps réel relatives à l’évolution de
                      vos dossiers et la position de vos marchandises
                    </li>
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0.1s"
                    >
                      <i className="icofont-check"></i>La maîtrise de vos coûts
                      de revient
                    </li>
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0.2s"
                    >
                      <i className="icofont-check"></i>L’optimisation des
                      procédures douanières
                    </li>
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0.3s"
                    >
                      <i className="icofont-check"></i>La négociation des
                      facilités douanières
                    </li>
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0.4s"
                    >
                      <i className="icofont-check"></i>Gestion du transfert des
                      marchandises de site à l’autre
                    </li>
                    <li
                      className="wow fadeInUp"
                      data-wow-duration="0"
                      data-wow-delay="0.5s"
                    >
                      <i className="icofont-check"></i>La maîtrise des risques
                      en commerce international
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wide-tb-100 pb-0 team-section-bottom pos-rel">
          <div className="container">
            <div className="col-sm-12">
              <h1 className="heading-main">
                <span>Les faces derrière Log2Trans</span>
                Notre Equipe
              </h1>
            </div>
            <div className="row pb-4">
              <div
                className="col-sm-12 col-md-4 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <div className="team-section-two">
                  <img
                    src="images/team/georges.jpeg"
                    alt=""
                    className="rounded"
                  />
                  <h4 className="h4-md txt-orange">
                    Georges kimmy Legrand ETAME
                  </h4>
                  <h5 className="h5-md txt-ligt-gray">Directeur Général</h5>
                </div>
              </div>
              <div
                className="col-sm-12 col-md-4 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0.1s"
              >
                <div className="team-section-two">
                  <img
                    src="images/team/team2.jpeg"
                    alt=""
                    className="rounded"
                  />
                  <h4 className="h4-md txt-orange">Emerant KENDA</h4>
                  <h5 className="h5-md txt-ligt-gray">
                    Responsable Administratif Comptable et Financière
                  </h5>
                </div>
              </div>
              <div
                className="col-sm-12 col-md-4 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="team-section-two">
                  <img
                    src="images/team/team3.jpeg"
                    alt=""
                    className="rounded"
                  />
                  <h4 className="h4-md txt-orange">Pierre Steve OTYAM</h4>
                  <h5 className="h5-md txt-ligt-gray">
                    Responsable Technique Logistique et Transport
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white wide-tb-100 mb-spacer-md">
          <div className="container">
            <div className="col-sm-12">
              <h1 className="heading-main">
                <span>Nous </span>
                Contacter
              </h1>
            </div>
            <div className="row">
              <div
                className="col-lg-4 wow fadeInRight"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="align-self-stretch h-100 align-items-center d-flex bg-with-text">
                  Que vous ayez besoin d'une distribution ou d'une exécution,
                  d'une expédition de fret définie ou d'une solution complète de
                  chaîne d'approvisionnement, nous sommes là pour vous.
                </div>
              </div>
              <div className="w-100 d-none d-sm-block d-lg-none spacer-60"></div>
              <div
                className="col-lg-8 wow fadeInLeft"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <form
                  action="#"
                  method="post"
                  noValidate="novalidate"
                  className="rounded-field gray-field"
                >
                  <div className="form-row mb-4">
                    <div className="col">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                      />
                    </div>
                  </div>
                  <div className="form-row mb-4">
                    <div className="col">
                      <select
                        title="Please choose a package"
                        required=""
                        name="package"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                      >
                        <option value="">Transport Type</option>
                        <option value="Type 1">Type 1</option>
                        <option value="Type 2">Type 2</option>
                        <option value="Type 3">Type 3</option>
                        <option value="Type 4">Type 4</option>
                      </select>
                    </div>
                    <div className="col">
                      <select
                        title="Please choose a package"
                        required=""
                        name="package"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                      >
                        <option value="">Type of freight</option>
                        <option value="Type 1">Type 1</option>
                        <option value="Type 2">Type 2</option>
                        <option value="Type 3">Type 3</option>
                        <option value="Type 4">Type 4</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-row mb-4">
                    <div className="col">
                      <textarea
                        rows="7"
                        placeholder="Message"
                        className="form-control"
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-row text-center">
                    <button
                      type="submit"
                      className="form-btn mx-auto btn-theme bg-secondary"
                    >
                      Envoyer <i className="icofont-rounded-right"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <section className="wide-tb-100 bg-white pos-rel partners-section-modern">
          <div className="container">
            <div className="row">
              <div
                className="col-sm-12 wow fadeInDown text-center mb-4"
                data-wow-duration="0"
                data-wow-delay="0s"
              >
                <h1 className="heading-main">
                  <span>Nos Partenaires</span>
                  Des collaborations de confiance
                </h1>
              </div>

              <div
                className="col-sm-12 wow fadeInUp"
                data-wow-duration="0"
                data-wow-delay="0.2s"
              >
                <div className="partners-carousel-wrapper">
                  <div
                    className="owl-carousel owl-theme"
                    id="partners-carousel-about"
                  >
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/africacontainershipping.jpg"
                          alt="Africa Container Shipping"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/asecna.png"
                          alt="ASECNA"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/btc.png"
                          alt="BTC"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/gulfcam.png"
                          alt="Gulfcam"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/moleculesgas.png"
                          alt="Molecules Gas"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/novaplast.png"
                          alt="Novaplast"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/parlym.png"
                          alt="Parlym"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/neptune.png"
                          alt="Neptune"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/psl.jpg"
                          alt="PSL"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/tradex.png"
                          alt="Tradex"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/scdp.png"
                          alt="SCDP"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/ttc.png"
                          alt="TTC"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/zte.png"
                          alt="ZTE"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="client-logo-card-modern">
                        <img
                          src="images/clients/hydrac.jpg"
                          alt="Hydrac"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wide-tb-100 faqs">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h1 className="heading-main">
                  <span>Foire Aux</span>
                  Questions
                </h1>
              </div>
              <div className="col-sm-12">
                <div className="faq-accordion-wrapper">
                  <FAQItem
                    question="Qu'est-ce qu'un commissionnaire en douane agréé et en quoi consiste votre service de commission en douane ?"
                    answer="Un commissionnaire agréé en douane est une entreprise spécialisée dans les formalités douanières liées à l'importation et à l'exportation de marchandises. Nous agissons en tant qu'intermédiaire entre les entreprises et les autorités douanières, nous chargeant de la préparation et de la soumission des documents nécessaires pour le dédouanement des marchandises."
                    index={0}
                    isOpen={openIndex === 0}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Quelles sont les zones géographiques que vous servez et quels sont vos points d'ancrage principaux ?"
                    answer="Nous opérons principalement dans les régions de Douala, Kribi et Yaoundé, mais nous pouvons également desservir d'autres destinations selon les besoins de nos clients. Nos points d'ancrage principaux sont nos bureaux situés dans ces zones, d'où nous coordonnons nos opérations logistiques et douanières."
                    index={1}
                    isOpen={openIndex === 1}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Quels sont les services de logistique industrielle et pétrolière que vous proposez ?"
                    answer="Nous offrons une gamme complète de services de logistique industrielle et pétrolière, comprenant le transport, la manutention, le stockage et la distribution de marchandises pour les industries manufacturières et pétrolières. Nous mettons à disposition notre expertise pour répondre aux besoins spécifiques de nos clients dans ces secteurs."
                    index={2}
                    isOpen={openIndex === 2}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Pouvez-vous détailler vos services de transport et de manutention ?"
                    answer="Nous proposons des services de transport et de manutention pour le déplacement sécurisé et efficace de marchandises, qu'il s'agisse de chargement, de déchargement, de transfert entre les ports ou les entrepôts, ou de tout autre besoin de déplacement de marchandises."
                    index={3}
                    isOpen={openIndex === 3}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="En quoi consiste votre service d'intermédiation dans le commerce international ?"
                    answer="Notre service d'intermédiation dans le commerce international consiste à faciliter les transactions commerciales entre des parties situées dans des pays différents. Nous mettons en relation les acheteurs et les vendeurs, nous nous occupons des aspects logistiques et douaniers, et nous veillons à ce que les transactions se déroulent de manière fluide et conforme aux réglementations en vigueur."
                    index={4}
                    isOpen={openIndex === 4}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Offrez-vous des conseils en achat/vente à l'international et en procédures douanières ?"
                    answer="Oui, nous proposons des services de conseil en achat/vente à l'international pour aider nos clients à prendre des décisions éclairées lorsqu'ils achètent ou vendent des produits à l'étranger. De plus, nous offrons des conseils spécialisés en matière de procédures douanières pour garantir la conformité réglementaire et optimiser les processus d'importation et d'exportation."
                    index={5}
                    isOpen={openIndex === 5}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Comment puis-je bénéficier de vos services ?"
                    answer="Pour bénéficier de nos services, il vous suffit de nous contacter par téléphone, par e-mail ou en remplissant le formulaire de contact sur notre site web. Notre équipe se fera un plaisir de discuter de vos besoins spécifiques et de vous proposer des solutions adaptées à vos exigences."
                    index={6}
                    isOpen={openIndex === 6}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Quels sont les avantages de travailler avec votre entreprise ?"
                    answer="Les avantages de travailler avec notre entreprise incluent notre expertise approfondie dans les domaines de la logistique, du commerce international et des procédures douanières, ainsi que notre engagement à fournir des services de haute qualité, fiables et personnalisés à chaque client. De plus, notre capacité à nous associer à des partenaires spécialisés nous permet d'offrir des solutions complètes et intégrées à nos clients."
                    index={7}
                    isOpen={openIndex === 7}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Comment puis-je obtenir un devis pour vos services ?"
                    answer="Pour obtenir un devis personnalisé, veuillez nous contacter en nous fournissant des détails sur vos besoins spécifiques, tels que le type de marchandises, les quantités, les destinations, etc. Notre équipe évaluera vos besoins et vous fournira un devis détaillé et compétitif dans les plus brefs délais."
                    index={8}
                    isOpen={openIndex === 8}
                    onToggle={handleToggle}
                  />
                  <FAQItem
                    question="Où puis-je trouver plus d'informations sur votre entreprise et vos services ?"
                    answer="Vous pouvez trouver plus d'informations sur notre entreprise et nos services sur notre site web, où nous présentons nos offres détaillées ainsi que des témoignages de clients satisfaits. N'hésitez pas à nous contacter si vous avez des questions supplémentaires ou si vous souhaitez discuter de vos besoins spécifiques avec notre équipe."
                    index={9}
                    isOpen={openIndex === 9}
                    onToggle={handleToggle}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="wide-tb-80 bg-scroll bg-img-6 pos-rel callout-style-1">
                    <div className="bg-overlay blue opacity-60"></div>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-4 col-md-12 mb-0 wow slideInUp" data-wow-duration="0" data-wow-delay="0.1s">
                                <h4 className="h4-xl">Interested in working with Logzee?</h4>
                            </div>
                            <div className="col wow slideInUp" data-wow-duration="0" data-wow-delay="0.2s">
                                <div className="center-text">
                                    We don’t just manage suppliers, we micro-manage them. We have a consultative, personalized approach
                                </div>
                            </div>
                            <div className="col-sm-auto wow slideInUp" data-wow-duration="0" data-wow-delay="0.3s">
                                <a href="#" className="btn btn-theme bg-white bordered">Get In Touch <i className="icofont-rounded-right"></i></a>
                            </div>
                        </div>
                    </div>
                </section> */}
      </main>
    </>
  );
};
export default Content;
